import { gql, useQuery } from '@apollo/client';
import { Card, CardBody, CardHeader, CardTitle } from '@apollo/orbit';
import _ from 'lodash';
import React from 'react';

import { Loading } from 'src/components/common/loading/Loading';
import { NotFound } from 'src/components/common/notFound/NotFound';
import { ignorePermissionsErrors } from 'src/lib/apollo/catchErrors';
import { appLinkContext } from 'src/lib/apollo/link';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import {
  ProposalCheckSection,
  ProposalsCheckConfigVariantFragment,
} from '../../graphSettingsPage/proposalsPage/proposalCheckSection/ProposalCheckSection';
import { GraphRef } from '../../hooks/useGraphRef';

export const ProposalChecksConfigVariantPage = ({
  graphRef,
}: {
  graphRef: GraphRef;
}) => {
  const { data, loading } = useQuery<
    GraphQLTypes.ProposalChecksConfigVariantPageQuery,
    GraphQLTypes.ProposalChecksConfigVariantPageQueryVariables
  >(
    gql`
      query ProposalChecksConfigVariantPageQuery(
        $graphId: ID!
        $graphVariant: String!
      ) {
        service(id: $graphId) {
          id
          variant(name: $graphVariant) {
            id
            checkConfiguration {
              id
              ...ProposalsCheckConfigVariantFragment
            }
          }
        }
      }
      ${ProposalsCheckConfigVariantFragment}
    `,
    {
      variables: {
        graphId: graphRef.graphId,
        graphVariant: graphRef.graphVariant,
      },
      context: appLinkContext({ catchErrors: [ignorePermissionsErrors] }),
    },
  );

  const graph = data?.service;
  const variantCheckConfig = graph?.variant?.checkConfiguration;

  if (loading) {
    return <Loading />;
  } else if (!graph?.variant) {
    return <NotFound />;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>General proposal configuration</CardTitle>
      </CardHeader>
      <CardBody>
        <ProposalCheckSection
          graphId={graphRef.graphId}
          graphVariant={graphRef.graphVariant}
          variantCheckConfig={variantCheckConfig}
        />
      </CardBody>
    </Card>
  );
};
